import { ACTIVE_NETWORKS } from '@shared/utils/config/networks';
import { useEffect, useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import DTSendFunds from '@/components/asset/sendFunds/DTSendFunds';
import SendFundsController from '@/components/asset/sendFunds/SendFundsController';
import NetworkDropdown from '@/components/shared/NetworkDropdown';
import usePortfolioBalance from '@/hooks/portfolio/usePortfolioBalance';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import { getNetworkLogo, getTokenImageFromAssetItem } from '@/lib/misc/tokenImageHelper';
import { toLocaleShortString, toSpecialFixed } from '@/lib/misc/utils';
import TokenImage from '@/components/shared/TokenImage';
export default function TokenToSend({
  address,
  network
}: {
  address?: string;
  network?: number;
}) {
  const isMobile = useIsMobile();
  const defaultNetwork = ACTIVE_NETWORKS;
  const [toggleNetwork, setNetwork] = useState<number[]>(defaultNetwork);
  const {
    data: assetData,
    isLoading: assetDataIsLoading
  } = usePortfolioBalance({});
  const [showSend, setShowSend] = useState(false);
  const [tokenData, setTokenData] = useState({
    address: address || null,
    network: network || null
  });
  function handleSelectToken(assetData: any) {
    if (!assetData) return;
    const data = {
      address: assetData.contract_address || assetData.address,
      network: assetData.network
    };
    setTokenData(data);
    setShowSend(true);
  }
  useEffect(() => {
    if (address && network) {
      handleSelectToken({
        address: address,
        network: network
      });
    }
  }, [address, network]);
  const sortedTokens = assetData?.balances?.filter((x: any) => x?.contract_address).filter((x: any) => {
    if (toggleNetwork) {
      return toggleNetwork?.includes(x.network);
    }
    return true;
  }).sort((a: any, b: any) => {
    const aValue = Number(a.usd_value) || 0;
    const bValue = Number(b.usd_value) || 0;
    return bValue - aValue;
  }).filter(x => x.usd_value > 0);
  if (!isMobile && showSend && tokenData) {
    return <DTSendFunds tokenData={tokenData} setShowSend={setShowSend} />;
  }
  return <>
      {isMobile && showSend && tokenData ? <SendFundsController tokenData={tokenData} isOpen={showSend} onClose={() => setShowSend(false)} /> : null}
      <div key={`send-funds-${tokenData?.address}-${tokenData?.network}`} className='flex flex-col h-full'>
        <div className='flex justify-center items-center pb-2 lg:pt-2.5'>
          <div className='text-[16px] lg:text-[18px]'>Send</div>
        </div>
        <div className='flex items-center justify-between px-6 bg-genius-blue w-full h-[42px] text-[14px]'>
          <p>Ticker</p>

          <NetworkDropdown setNetwork={setNetwork} network={toggleNetwork} defaultNetwork={defaultNetwork} isMobile={isMobile} className='text-[14px]  justify-center' data-sentry-element="NetworkDropdown" data-sentry-source-file="TokenToSend.tsx" />

          <p>Balance</p>
        </div>

        <div className='h-full'>
          {assetDataIsLoading ? <p className='text-[16px] text-genius-cream'>Loading assets data...</p> : <AutoSizer>
              {({
            height,
            width
          }) => <List key={`${tokenData?.address}-${tokenData?.network}`} height={height} itemCount={sortedTokens.length} itemSize={60} width={width} className='no-scrollbar'>
                  {({
              index,
              style
            }) => {
              const item = sortedTokens[index];
              return <div style={style} className='flex items-center'>
                        <div className='w-full flex justify-between items-center hover:bg-genius-blue transition-colors px-6 h-full cursor-pointer' onClick={() => handleSelectToken(item)}>
                          <div className='flex items-center gap-4'>
                            <TokenImage mainImageSrc={getTokenImageFromAssetItem(item)} badgeImageSrc={getNetworkLogo(item?.network)} size={32} badgeSize={16} />
                            <div className='text-left'>
                              <p> {toLocaleShortString(item?.contract_name, 30)}</p>
                              <p className='opacity-50 text-xs'>
                                {toLocaleShortString(item?.contract_ticker_symbol)}
                              </p>
                            </div>
                          </div>
                          <div className='text-right'>
                            <p>${toSpecialFixed(item.usd_value).value}</p>
                            <p className='opacity-50 text-xs'>
                              {toSpecialFixed(item.formatted_balance).value}{' '}
                              {toLocaleShortString(item.contract_ticker_symbol, 3, true)}
                            </p>
                          </div>
                        </div>
                      </div>;
            }}
                </List>}
            </AutoSizer>}
        </div>
      </div>
    </>;
}